module.exports = __webpack_public_path__ + "static/media/default-employee.69d2ed55.jpg";